export enum LocumsFlags {
    LocumsMarginContractLink = 'locums-margin-contract-link',
    ViewExternalExpensesInInvoice = 'view-external-expenses-in-invoice',
    CandidatesGridPayrollReps = 'candidates-grid-payroll-reps',
    LocumsPayrollRepFilterShiftManagement = 'locums-payroll-rep-filter-shift-management',
    ConfirmedBookedDaysRequiredFields = 'confirmed-booked-days-required-fields',
    CandidateAssignPayrollRep = 'candidate-assign-payroll-rep',
    ScheduleBookedDayFloatPoolLocation = 'schedule-booked-day-float-pool-location',
    LocumsCandidateProfilesDisplayLocumsPayrollRep = 'locums-candidate-profiles-display-locums-payroll-rep',
    LocumsMarginPipelineRequest = 'locums-margin-pipeline-request',
    AddDegreeFieldToCandidateAboutSection = 'add-degree-field-to-candidate-about-section',
    LocumsPayrollRep = 'locums-payroll-rep',
    AddPayRateAndTravelRequestedInJobSubmittal = 'add-pay-rate-and-travel-requested-in-job-submittal',
    LocumsMarginProviderAssignments = 'margin-t-provider-assignments',
    LocumsPipelineRequestSummaryOfChanges = 'locums-pipeline-request-summary-of-changes',
    AMLiveListLinkToMarginCalculator = 'am-live-list-link-to-margin-calculator',
    LocumsMarginExpensesExtendedAmount = 'locums-margin-expenses-extended-amount',
    LocumsMarginRtoDates = 'margin-rto-dates',
    LocumsPipelineRequestPerformanceOptimized = 'locums-pipeline-request-performance-optimized',
    LocumsMarginExpensesHideCadence = 'locums-margin-expenses-hide-cadence',
    DisplayJobProfessionAndSpecialtyInCr = 'display-job-profession-and-specialty-in-cr',
    AutoHideFacilityNameForLocums = 'auto-hide-facility-name-for-locums',
    AllowUpdatingPendingAmReviewRequest = 'allow-updating-pending-am-review-request',
    ShowFluVaccinationInformation = 'show-flu-vaccination-information',
    ContractProfileBackgroundFields = 'contract-profile-background-fields',
    CandidateProfileInterviewAvailability = 'candidate-profile-interview-availability',
    LocumsScheduleSummaryNotifications = 'locums-schedule-summary-notifications',
    LocumsSubmittalPersonalInformation = 'locums-submittal-personal-information',
    LocumsSubmittalProfessionalInformation = 'locums-submittal-professional-information',
    Locums1099SubmittalsCreatePresentation = 'locums-1099-submittals-create-presentation',
    LocumsSubmittalBackgroundInformation = 'locums-submittal-background-information',
    LocumsResetNPIStatusOnNPIChange = 'locums-reset-npi-status-on-npi-change',
    LocumsPresentationHideNonLocumsSections = 'locums-presentation-hide-non-locums-sections',
    LocumsSubmittalDefaultDocuments = 'locums-submittal-default-documents'
}
